import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useAiQuotaExceededModal } from '../context/AiQuotaExceededModalContext';

const AiQuotaExceededModalFooter: FC = () => {
  const { t } = useTranslate();
  const { actions } = useAiQuotaExceededModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-outline-light"
        onClick={actions.handleCloseModal}
      >
        {t('Close')}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={actions.handleUpgrade}
      >
        {t('AI_UpgradePlan')}
      </button>
    </Modal.Footer>
  );
};

export default AiQuotaExceededModalFooter;
